import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { destinosAPI } from "../../utils/funcionesAPI";
import Slider from "react-slick";
import carouselSettings from "./carouselSettings";
import { transformText } from "../../utils/Tools";
//import { manejadorDeRespuesta } from '../../utils/Tools'

const Categorias = (props) => {
  const [grupos, setGrupos] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { origen, fecha, onGrupoClick } = props;
  //const fondos = ["azul"];
  const names = ['Fernando', 'Emilio', 'Elias', 'Alejandro', 'Bernardo', 'Julian', 'Leopoldo', 'Nicolas', 'Juan', 'Georgeva', 
    'Marisa', 'Carla', 'Mary', 'Irene', 'Laura', 'Jesica', 'Dibu']; 
  const indiceAleatorio = Math.floor(Math.random() * names.length);
  let settings = carouselSettings[1];
  settings.infinite = true;
  if (settings.slidesToShow >= grupos.length) settings.infinite = false;

  const traerCategorias = (origen) => {
    let data = JSON.stringify({
      peticion: "gruposComerciales",
      origen: origen || "CENT",
    });
    setLoaded(false);
    destinosAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(_this.props, respuesta))
      if (respuesta) {
        if (respuesta.estado !== "error") {
          setLoaded(true);
          setGrupos(respuesta.data);
        }
      }
    });
  };

  useEffect(() => {
    traerCategorias(origen);
  }, [origen]);

  const handleGrupoClick = (event) => {
    onGrupoClick(event.target.id);
  };

  const array_move = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };
/*
  const elegirFondo = (array) => {
    //array[Math.floor(Math.random() * array.length)]
    array_move(array, 0, array.length - 1);

    return array[0];
  };
*/
  return (
    <section className="categorias">
      <div className="container">
        <div className="carousel-categorias">
          {loaded && (
            <Slider {...settings}>
              {grupos.map((grupo) => {
                return (
                  <div
                    className="categoria"
                    id={grupo.idGrupo}
                    key={grupo.idGrupo}
                    onClick={handleGrupoClick}
                  >
                    <Link
                      to={`/paquetes-turisticos/${origen || "CENT"}/0/${fecha}/0/${grupo.idGrupo}/${encodeURI(grupo.descripcion)}`}
                    >
                      <div style={{borderRadius: 50, textAlign: "center", padding: 20, margin: 20, textTransform: 'uppercase', height: 150, 
                                  display: 'flex', flexDirection: 'column', justifyItems: 'center', justifyContent: "center", alignItems: 'center', 
                                  alignSelf: 'center', backgroundColor: '#D6E8F5', 
                                  background: 'linear-gradient(13deg, rgba(184, 194, 251, 1.0) 0%, rgba(208, 247, 251, 1.0) 100%)', 
                                  boxShadow: '-2px 3px 21px -3px rgba(36, 36, 36, 0.55)' }}>
                        <h2 style={{color: '#002552', textWrap: 'balance', wordSpacing: '0.1rem'}}>
                        {transformText(grupo.descripcion)} {(grupo.idGrupo == 72 || grupo.idGrupo == 73) && `Sugiere ${transformText(names[indiceAleatorio])}`}
                        </h2>
                        <h6 style={{color: '#033067', fontSize: '14px'}}>conoc&eacute; los destinos</h6>
                        </div>
                      
                    </Link>
                  </div>
                );
              })}
            </Slider>
          )}
        </div>
      </div>
    </section>
  );
};

/*
<div className={`destinos-card ${elegirFondo(fondos)}`}>
                        <h2>{transformText(grupo.descripcion)} {(grupo.idGrupo == 72 || grupo.idGrupo == 73) && `Sugiere ${transformText(names[indiceAleatorio])}`}</h2>
                        <h6>conoc&eacute; los destinos</h6>
                      </div>
*/

export default Categorias;



// WEBPACK FOOTER //
// ./src/components/Home/Categorias.js